// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__R-HGQ","info":"UpdateTermsInfo_info__R_00n"};